import { render, staticRenderFns } from "./modalVerLiquidador.vue?vue&type=template&id=74635f69&scoped=true"
import script from "./modalVerLiquidador.vue?vue&type=script&lang=js"
export * from "./modalVerLiquidador.vue?vue&type=script&lang=js"
import style0 from "./modalVerLiquidador.vue?vue&type=style&index=0&id=74635f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74635f69",
  null
  
)

export default component.exports